import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download, X } from "lucide-react";
import { triggerInstall } from "@/lib/pwa";

const DISMISS_KEY = "ec-install-prompt-dismissed-v1";

export function InstallPromptBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (localStorage.getItem(DISMISS_KEY)) return;
    if ((window.matchMedia("(display-mode: standalone)").matches) || (window.navigator as any).standalone) return;

    const onPrompt = () => setShow(true);
    window.addEventListener("entertaincrm:pwa:available", onPrompt as EventListener);

    return () => window.removeEventListener("entertaincrm:pwa:available", onPrompt as EventListener);
  }, []);

  if (!show) return null;

  function dismiss() {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setShow(false);
  }

  async function install() {
    const ok = await triggerInstall();
    if (ok) setShow(false);
  }

  return (
    <div
      className="fixed bottom-20 md:bottom-4 left-3 right-3 md:left-auto md:right-4 md:max-w-sm z-40 rounded-lg border bg-background shadow-lg p-3 flex items-center gap-3"
      data-testid="banner-install-prompt"
    >
      <div className="rounded-md bg-primary/10 p-2">
        <Download className="h-5 w-5 text-primary" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium">Install Clarik</div>
        <div className="text-xs text-muted-foreground">Add it to your home screen for one-tap access.</div>
      </div>
      <Button size="sm" onClick={install} data-testid="button-install-pwa">Install</Button>
      <button
        onClick={dismiss}
        className="text-muted-foreground hover:text-foreground"
        aria-label="Dismiss"
        data-testid="button-dismiss-install"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
